import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {
  imageUrl: SafeUrl;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: {imageUrl: string, safe: boolean | undefined},
      private sanitizer: DomSanitizer
  ) {
    if (this.data.safe) {
      this.imageUrl = this.data.imageUrl;
    } else {
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.data.imageUrl);
    }
  }

  ngOnInit(): void {}

}
